import OrderPaymentApi from '@apis/order/OrderPaymentApi';
import Loading from '@components/Loading';
import { CreateOrderRequest } from '@models/order';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { orderActions } from '@store/order/orderSlice';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';

interface Params {
    paymentKey: string;
    orderId: string;
    amount: number;
}

const TossOrderSuccessActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { paymentKey, orderId, amount } = params;
    const { push, replace } = useFlow();
    const dispatch = useDispatch();

    const [cookies, _, removeCookie] = useCookies(['tempOrder'], { doNotParse: true });
    const handleFail = () => {
        try {
            const tempOrder: CreateOrderRequest = JSON.parse(cookies.tempOrder);
            const { shopId } = tempOrder;
            const itemId = tempOrder.orderLines.map((line) => line.shopItemId)
                ?.[0];
            push('ShopListActivity', { type: 'LIST', isOrder: true }, { animate: false });
            push('ItemsActivity', { type: 'ALL', shopId }, { animate: false });
            push('ItemActivity', { itemId, shopId }, { animate: false });
            push('OrderActivity', { }, { animate: false });
            dispatch(orderActions.copy(JSON.parse(cookies.tempOrder!)));
        } catch (e) {
            console.error(e);
            replace('MainActivity', {});
        } finally {
            toast.error('주문에 실패하였습니다.');
        }
    };

    useEffect(() => {
        console.log('toss 결제 승인 요청');
        OrderPaymentApi.paymentToss({
            paymentKey, orderNo: orderId, amount,
        }).then(() => {
            replace('MainActivity', {}, { animate: false });
            push('OrderLogsActivity', { duration: 'ALL' }, { animate: false });
            push('OrderLogActivity', { orderNo: orderId });
            removeCookie('tempOrder', { path: '/' });
        }).catch((reason) => {
            toast.error('주문에 실패하였습니다.');
            console.error(reason);
            handleFail();
        });
    }, []);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default TossOrderSuccessActivity;
